import Cookies from 'js-cookie'
import { v4 as UUID } from 'uuid'
import { ct_sid_name, ct_vid_name } from '../models'


const getUUId = () => `${UUID()}${UUID()}${UUID()}${UUID()}`

const getOneHourTime = () => {
  const now = new Date()
  let time = now.getTime()
  time += 1000 * 60 * 60// One Hour
  now.setTime(time)
  return now
}

export const setNewCtSidCookie = () => {
  Cookies.set(ct_sid_name, getUUId(), { expires: getOneHourTime(), domain: process.env.CT_DOMAIN, })
}

export const updateCtSidCookie = () => {
  const oldValue = getCtCookie(ct_sid_name)
  Cookies.set(ct_sid_name, oldValue, { expires: getOneHourTime(), domain: process.env.CT_DOMAIN, })
}

export const setNewCtVidCookie = () => {
  Cookies.set(ct_vid_name, getUUId(), { expires: 720, domain: process.env.CT_DOMAIN, })
}

export const updateCtVidCookie = () => {
  const oldValue = getCtCookie(ct_vid_name)
  Cookies.set(ct_vid_name, oldValue, { expires: 720, domain: process.env.CT_DOMAIN, })
}

type CTCookieKeyType =
  typeof ct_sid_name |
  typeof ct_vid_name |
  'ct-country' |
  'ct-language' |
  'ct-currency'

export const getCtCookie = (key: CTCookieKeyType): string => Cookies.get(key)

export const updateCTCookie = (
  key: CTCookieKeyType,
  value: string,
  headers = { domain: process.env.CT_DOMAIN, path: '/' }
) => {
  const oldCookie = getCtCookie(key)
  if (oldCookie) Cookies.remove(key, headers)
  Cookies.set(key, value, headers)
}
export const setLoginCookie = () => {
  const expirationDate = new Date()
  expirationDate.setMonth(expirationDate.getMonth() + 3)
  Cookies.set('ct_loggedIn', 'true', {
    domain: process.env.CT_DOMAIN,
    path: '/',
    expires: expirationDate,
  })
}
export const checkLoggedInCookie = () => {
  const cookieValue = document.cookie
    .split('; ')
    .find(row => row.startsWith(`ct_loggedIn=`))
    ?.split('=')[1]

  return cookieValue === 'true'
}
